import { render } from "./ReferenciaForm.vue?vue&type=template&id=1c38b6ef&scoped=true"
import script from "./ReferenciaForm.vue?vue&type=script&lang=js"
export * from "./ReferenciaForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=1c38b6ef&scoped=true&lang=css"
import "./ReferenciaForm.vue?vue&type=style&index=1&id=1c38b6ef&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c38b6ef"]])

export default __exports__